import React, { useState } from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import {
  Heading,
  NamedLink,
  InlineTextButton,
  IconClose,
  PrimaryButton,
  SetupLoadingNotice,
} from '../../components';
import ProgressIndicator from '../../components/ProgressIndicator';

import css from './AuthenticationPage.module.css';
import checkEmailVideo from '../../assets/repoze_website-animations_check-your-email_1200px.mp4';

const SETUP_NOTICE_DURATION = 15000;

const EmailVerificationInfo = props => {
  const {
    name,
    email,
    onResendVerificationEmail,
    resendErrorMessage,
    sendVerificationEmailInProgress,
  } = props;

  const [proceedLocked, setProceedLocked] = useState(true);

  const resendEmailLink = (
    <InlineTextButton rootClassName={css.modalHelperLink} onClick={onResendVerificationEmail}>
      <FormattedMessage id="AuthenticationPage.resendEmailLinkText" />
    </InlineTextButton>
  );

  const fixEmailLink = (
    <NamedLink className={css.modalHelperLink} name="ContactDetailsPage">
      <FormattedMessage id="AuthenticationPage.fixEmailLinkText" />
    </NamedLink>
  );

  const proceedLabel = <FormattedMessage id="AuthenticationPage.proceedToProfile" />;

  return (
    <div className={css.content}>
      <NamedLink className={css.verifyClose} name="ProfileSettingsPage">
        <span className={css.closeText}>
          <FormattedMessage id="AuthenticationPage.verifyEmailClose" />
        </span>
        <IconClose rootClassName={css.closeIcon} />
      </NamedLink>
      <video className={css.emailCheck} autoPlay loop muted playsInline>
        <source src={checkEmailVideo} type="video/mp4" />
      </video>
      <Heading as="h1" rootClassName={css.modalTitle}>
        <FormattedMessage id="AuthenticationPage.verifyEmailTitle" values={{ name }} />
      </Heading>
      <p className={css.modalMessage}>
        <FormattedMessage id="AuthenticationPage.verifyEmailText" values={{ email }} />
      </p>
      {resendErrorMessage}

      <div className={css.bottomWrapper}>
        <p className={css.modalHelperText}>
          {sendVerificationEmailInProgress ? (
            <FormattedMessage id="AuthenticationPage.sendingEmail" />
          ) : (
            <FormattedMessage id="AuthenticationPage.resendEmail" values={{ resendEmailLink }} />
          )}
        </p>
        <p className={css.modalHelperText}>
          <FormattedMessage id="AuthenticationPage.fixEmail" values={{ fixEmailLink }} />
        </p>

        {/* Progress Indicator - all steps completed, no click functionality */}
        <ProgressIndicator
          currentStep={3}
          totalSteps={3}
          className={css.progressIndicator}
          onStepClick={null} // Disable clicking
        />

        <SetupLoadingNotice
          timeoutDuration={SETUP_NOTICE_DURATION}
          onAnimationComplete={() => setProceedLocked(false)}
        />

        {/* Proceed to profile button */}
        {proceedLocked ? (
          <PrimaryButton disabled className={css.proceedButton}>
            {proceedLabel}
          </PrimaryButton>
        ) : (
          <NamedLink
            name="ProfileSettingsPage"
            to={{ search: 'signup=true' }}
            className={css.proceedButton}
          >
            <PrimaryButton>{proceedLabel}</PrimaryButton>
          </NamedLink>
        )}
      </div>
    </div>
  );
};

export default EmailVerificationInfo;
